import { Injectable } from "@angular/core";
import { HttpRequestHistoryItem } from "../models/http-request-history-item.model";

@Injectable({providedIn: "root"})
export class HttpRequestHistoryService {

    private readonly maximumItemCount = 30;
    private readonly items: HttpRequestHistoryItem[] = [];
    private readonly errors = new WeakMap<object, HttpRequestHistoryItem>();

    add(item: HttpRequestHistoryItem): void {
        this.items.push(item);
        if (this.items.length > this.maximumItemCount) {
            this.items.splice(0, this.items.length - this.maximumItemCount);
        }
    }

    getSnapshot(): HttpRequestHistoryItem[] {
        return this.items.slice();
    }

    associateError(error: object, item: HttpRequestHistoryItem): void {
        this.errors.set(error, item);
    }

    getForError(error: object): HttpRequestHistoryItem {
        return this.errors.get(error);
    }

    parseUrl(value: string): {route: string; queryParameterNames: string[]} {
        if (value == null || value == "") {
            return {route: null, queryParameterNames: []};
        }
        try {
            let url = new URL(value, window.location.origin);
            let route = url.origin == window.location.origin ? url.pathname : url.origin + url.pathname;
            return {
                route,
                queryParameterNames: Array.from(new Set(url.searchParams.keys())).sort()
            };
        }
        catch {
            return {
                route: value?.split("?", 1)[0].split("#", 1)[0],
                queryParameterNames: []
            };
        }
    }
}
